export { UnderConstructionComponent } from './under-construction';
export { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/components/index.ts